import React from 'react'

import ModalV5 from "../../../../app/ui/modal/v5/v5"
import {MoveTo_Manager} from "../model/manager"
import ErrorBoundary from "../../../error-boundary"
import {MoveTo_CurrentStep} from "../@const"
import ModalV5_Header from "../../../../app/ui/modal/v5/header/header"
import ModalMoveTo_Project from "./project/move-to-project"
import Loading from "../../../gd-ui/loading/loading"
import ModalMoveTo_SubtasksError from "./subtasks-error/subtasks-error"
import Modal_StateMessage from "../../components/state-message/state-message"
import {useForceUpdate} from "../../../gd/utils/dom-and-react/react-utils"
import Modal_AddMissingUsersTeams from "../../components/add-missing-users-and-teams/add-missing-users-and-teams"
import {EntityType} from "../../../gd/const/item"
import ModalMoveTo_Task from "./task/move-to-task"

type Props = {
    manager     : MoveTo_Manager
}

// const debug = "ModalMoveTo"
const debug = false

export default function ModalMoveTo(props:Props) {

    const manager : MoveTo_Manager = props.manager
    manager.reRender = useForceUpdate()

    debug && console.log(debug, 'render', props.manager.currentStep)

    let content
    switch(props.manager.currentStep) {

        case MoveTo_CurrentStep.MAIN:
            switch (props.manager.targetType) {
                case EntityType.PROJECT:
                    content = <ModalMoveTo_Project manager={props.manager} />
                    break

                case EntityType.TASK:
                    content = <ModalMoveTo_Task manager={props.manager} />
                    break
            }
            break

        case MoveTo_CurrentStep.SUBTASKS_ERROR:
            content = <ModalMoveTo_SubtasksError/>
            break

        case MoveTo_CurrentStep.CHECKING_USERS:
            content = <Modal_StateMessage message="Checking users..."/>
            break

        case MoveTo_CurrentStep.ADD_MISSING_USERS:
            content = <Modal_AddMissingUsersTeams manager={props.manager}/>
            break

        case MoveTo_CurrentStep.MOVING:
            content = <Modal_StateMessage message="Moving..."/>
            break

        case MoveTo_CurrentStep.LOADING:
        default:
            return <Loading />
    }

    return (
        <ModalV5 className="w-650 h-85p flex-column">
            <ModalV5_Header title={props.manager.modalTitle} underline={false} />

            <ErrorBoundary>
                {content}
            </ErrorBoundary>
        </ModalV5>
    )
}
